import React, { useState, useEffect, useMemo, useCallback,useContext } from "react";

import {
  Table,
  Tag,
  Layout,
  message,
  Spin,
  Space,
  DatePicker,
  Button,
  Select,
  Modal,
  Tooltip,
} from "antd";
import HeaderLayout from "../../layout/Header";
import NavBarLayout from "../../layout/NavBar";
import FooterLayout from "../../layout/Footer";
import { secondsToHHMMSS } from "../../utils/Common";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { getDataUser } from "../../services/instanceUserService";
import { UserContext } from "../../components/call/UserContext";
import { formatDateToYYYYMMDDHHMMSS, getShortDate } from "../../utils/Common";
import { isMobile } from "react-device-detect";
import {
  PauseCircleOutlined,
  PlayCircleOutlined,
  CloudDownloadOutlined,
  ReloadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  downloadCallData,
  getCallData,
} from "../../services/instanceCallService";
import jaJP from "antd/locale/ja_JP";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  horizontalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
const { Content } = Layout;

function useCurrentTime() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return currentTime;
}

function CurrentTimeDisplay() {
  const currentTime = useCurrentTime();

  const year = currentTime.getFullYear();
  const month = String(currentTime.getMonth() + 1).padStart(2, "0");
  const date = String(currentTime.getDate()).padStart(2, "0");

  const hours = String(currentTime.getHours()).padStart(2, "0");
  const minutes = String(currentTime.getMinutes()).padStart(2, "0");
  const seconds = String(currentTime.getSeconds()).padStart(2, "0");

  const dateString = `${year}/${month}/${date}`;
  const timeString = `${hours}:${minutes}:${seconds}`;

  return (
    <div style={styles.container}>
      <span style={styles.text}>{dateString}</span>
      <span style={styles.text}>{timeString}</span>
    </div>
  );
}
const DraggableHeaderCell = ({ children, ...props }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: props["data-column-key"] });

  const style = {
    ...props.style,
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1 : 0,
    background: isDragging ? "#e6f7ff" : undefined,
  };

  return (
    <th {...props} ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </th>
  );
};
const CallReportZoom = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setWaiting] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [reportData, setReportData] = useState([]);
  const [updatedUser, setUpdatedUser] = useState([]);
  const [sysUserData, setSysUserData] = useState([]);
  const { author, setUser } = useContext(UserContext);

  const [logData, setLogData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [audio, setAudio] = useState(null);
  const [isPlaying, setIsPlaying] = useState("");
  const [isDownloading, setIsDownloading] = useState("");
  const [currentAudioId, setCurrentAudioId] = useState(null);
  const [filteredData, setFilteredData] = useState(null);

  const curUserID = author?.id;
  const curUserName = author?.name;
  const isAdmin = author?.is_admin;
  const sortStorageKey = "report_sort_state";

  const [sortState, setSortState] = useState(() => {
    const saved = localStorage.getItem(sortStorageKey);
    return saved ? JSON.parse(saved) : {};
  })
  let [searchParams, setSearchParams] = useSearchParams();
  const is_enterprise = searchParams.get("is_enterprise");
  const date = searchParams.get("filter");
  const type = searchParams.get("type");
  let urlAPI = '/call-log/me?';
  let logurlAPI = '/call-log/list?';
  const reportStorageKey = "report_column_order";
  const logStorageKey = "calllog_column_order";

  const user_id = searchParams.get("user_id");

  const optCurUsers = [
    {
      label: curUserName,
      value: curUserID,
    },
  ];

  const handleUpdateUser = (user_id, user_name) => {
    // Add or update the user in updatedUser state
    setUpdatedUser((prevState) => ({
      ...prevState,
      [user_id]: { label: user_name, value: user_id },
    }));
  };

  const fetchSysUser = async () => {
    if (isAdmin) {
      try {
        const result = await getDataUser("/users");
        setSysUserData(result.data.data || []);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        //setIsLoading(false);
      }
    } else {
      setSysUserData([]);
    }
  };

  const optSysUsers = useMemo(() => {
    if (Array.isArray(sysUserData) && sysUserData.length > 0) {
      return sysUserData.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }
    return []; // Default to empty array
  }, [sysUserData]);


  useEffect(() => {
    const fetchReport = async () => {
      setIsLoading(true);

      try {
        if (user_id){
          urlAPI = `${urlAPI}&user_id=${user_id}`;
          // Get the user details from optSysUsers or optCurUsers
          const user = optSysUsers.find((u) => u.value === user_id) || [];

          if (user) {
            handleUpdateUser(user.value, user.label);
          }
        }
        if (type === "date" && date) {
          const result = await getCallData(`${urlAPI}&date=${date}`);
          setReportData(result.data);
        } else if (type === "month" && date) {
          const result = await getCallData(`${urlAPI}&month=${date}`);
          setReportData(result.data);
        } else {
          const result = await getCallData(`${urlAPI}`);
          setReportData(result.data);
        }
      } catch (error) {
        console.log("Error fetching workgroups:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchReport();
    fetchSysUser();
  }, [searchParams]);

  const handleDateChange = (date, dataString) => {
    if (date) {
      if(user_id){
          setSearchParams({ filter: date?.format("YYYY-MM-DD"), type: "date", user_id: user_id });
      } else {
          setSearchParams({ filter: date?.format("YYYY-MM-DD"), type: "date" });
      }
    } else {
      searchParams.delete("filter");
      searchParams.delete("type");
      searchParams.delete("user_id");
      setSearchParams(searchParams);
    }
  };

  const handleChangeMonth = (date, dataString) => {
    if (date) {
      if(user_id){
          setSearchParams({ filter: date?.format("YYYY-MM"), type: "month", user_id: user_id });
      } else {
          setSearchParams({ filter: date?.format("YYYY-MM"), type: "month" });
      }
    } else {
      searchParams.delete("filter");
      searchParams.delete("type");
      searchParams.delete("user_id");
      setSearchParams(searchParams);
    }
  };

  const handleChangeUser = (user_id, dataString) => {
    if (user_id) {
      setSearchParams({ user_id: user_id});
      // Get the user details from optSysUsers or optCurUsers
      const user = optSysUsers.find((u) => u.value === user_id) || optCurUsers[0];

      if (user) {
        handleUpdateUser(user.value, user.label);
      }
    } else {
      searchParams.delete("user_id");
      searchParams.delete("filter");
      searchParams.delete("type");
      setSearchParams(searchParams);
    }
  };

  const columns = [
    {
      title: "名前",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => handleChangeUser(record.id)}
        >
          <Tag color={"#77f"}>{record.name}</Tag>
        </Button>
      ),
      width: 120,
      filters: [...new Set(reportData.map(item => item.callerName).filter(Boolean))]
        .map(name => ({ text: name, value: name })),
    onFilter: (value, record) => record.name === value,
    },
    {
        title: '部署',
        dataIndex: 'department_name',
        key: 'department_name',
        width: 100,
        filters: [...new Set(reportData.map(item => item.department_name).filter(Boolean))]
            .map(name => ({ text: name, value: name })),
        onFilter: (value, record) => record.department_name === value,
    },
    {
        title: '課',
        dataIndex: 'section_name',
        key: 'section_name',
        width: 100,
        filters: [...new Set(reportData.map(item => item.section_name).filter(Boolean))]
            .map(name => ({ text: name, value: name })),
        onFilter: (value, record) => record.section_name === value,

    },
    {
        title: 'チーム',
        dataIndex: 'team_name',
        key: 'team_name',
        width: 120,
        filters: [...new Set(reportData.map(item => item.team_name).filter(Boolean))]
            .map(name => ({ text: name, value: name })),
        onFilter: (value, record) => record.team_name === value,
    },
    {
      title: "架電数",
      dataIndex: "hit_call_per_day",
      key: "hit_call_per_day",
      width: 120,
      render: (hit_call_per_day) => (
        <Tag color={"#52c41a"}>{hit_call_per_day}</Tag>
      ),
      sorter: (a, b) => a.hit_call_per_day - b.hit_call_per_day,
    },
    {
      title: "通電数",
      dataIndex: "call_per_day",
      key: "call_per_day",
      width: 120,
      render: (call_per_day) => <Tag color={"#52c41a"}>{call_per_day}</Tag>,
      sorter: (a, b) => a.call_per_day - b.call_per_day,
    },
    {
      title: "アポ数",
      key: "number_of_appointment",
      dataIndex: "number_of_appointment",
      width: 150,
      render: (number_of_appointment) => (
        <Tag color={"#52c41a"}>{number_of_appointment}</Tag>
      ),
      sorter: (a, b) => a.number_of_appointment - b.number_of_appointment,
    },
    {
      title: "断り数",
      key: "per_refuse",
      dataIndex: "per_refuse",
      width: 150,
      render: (per_refuse) => (
        <Tag color={"#f55"}>{per_refuse}</Tag>
      ),
      sorter: (a, b) => a.per_refuse - b.per_refuse,
    },
    {
      title: "つながり率",
      key: "called_rate",
      dataIndex: "called_rate",
      width: 120,
      render: (called_rate) => (
        called_rate == null
          ? <Tag color={"#f55"}>-</Tag>
          : <Tag color={"#f55"}>{parseFloat(called_rate).toFixed(2)} %</Tag>
      ),
      sorter: (a, b) => a.called_rate - b.called_rate,
    },

    {
      title: "合計通話",
      dataIndex: "total_duration",
      key: "total_duration",
      render: (connection_date) => (
        <Tag color={"#52c41a"}>{secondsToHHMMSS(connection_date)}</Tag>
      ),
      width: 130,
      sorter: (a, b) => a.total_duration - b.total_duration,    },
      {
         title: "架電間隔時間/日",
          dataIndex: "total_interval_average",
          key: "total_interval_average",
          render: (total_interval_average) => (
            <Tag color={"#52c41a"}>{total_interval_average}</Tag>
          ),
          width: 130,
          sorter: (a, b) => {
            if (!a.total_interval_average) return -1;
            if (!b.total_interval_average) return 1;
            return a.total_interval_average.localeCompare(b.total_interval_average);
          },
        }
  ];

  const repData = (reportData) => {
    if (!Array.isArray(reportData)) {
      throw new TypeError("reportData must be an array");
    }
    return reportData.map((item, index) => ({
      key: index + 1,
      id: item.user_id,
      department_name: item.department_name,
      section_name: item.section_name,
      team_name: item.team_name,
      name: item.callerName,
      connection_date: item.call_date,
      hit_call_per_day: item.hitPerDay,
      call_per_day: item.hitAppointment,
      number_of_appointment: item.callPerStatus,
      called_rate: item.calledRate || 0,
      total_duration: item.totalDuration,
      per_refuse: item.perRefuse,
      total_interval_average: item.totalIntervalAverage,
    }));
  };

  const exportCSVData = () => {
    // フィルター後のデータがあればそれを使い、無ければ全データを使う
    const sourceData = filteredData ?? repData(reportData);

    if (sourceData && sourceData.length > 0) {
      const csvDataExp = sourceData.map((row) => ({
        名前: row.name,
        部署: row.department_name,
        課: row.section_name,
        チーム: row.team_name,
        架電数: row.hit_call_per_day || 0,
        通電数: row.call_per_day || 0,
        アポ数: row.number_of_appointment || 0,
        断り数: row.per_refuse || 0,
        つながり率:
          row.called_rate == null
            ? "0.0%"
            : parseFloat(row.called_rate).toFixed(1) + "%",
        合計通話:
          (row.total_duration &&
            row.total_duration !== 0 &&
            `${Math.floor(row.total_duration / 60)}:${
              row.total_duration % 60 < 10 ? "0" : ""
            }${row.total_duration % 60}`) ||
          0,
        "架電間隔時間/日": row.total_interval_average,
      }));

      const now = dayjs();
      const formattedDate = now.format("YYYY-MM-DD");
      const bom = "\uFEFF";
      const csv = bom + Papa.unparse(csvDataExp, { header: true });
      const blob = new Blob([csv], { type: "text/csv;charset=ansi" });
      saveAs(blob, date == null ? formattedDate : date + "-Report.csv");
    } else {
      messageApi.error("Error fetching candidates");
      setWaiting(false);
    }
  };
  const togglePlayPause = useCallback(
      async (logId) => {
        setWaiting(true);
        if (currentAudioId && currentAudioId === logId) {
          if (audio) {
            if (audio.paused) {
              audio.play();
              setIsPlaying(logId);
            } else {
              audio.pause();
              setIsPlaying("");
            }
          }
          setWaiting(false);
          return;
        }
        if (audio) window.URL.revokeObjectURL(audio.src);
  
        try {
          const audioFile = await fetchAudio(logId);
  
          if (audioFile) {
            const url = window.URL.createObjectURL(audioFile);
            const newAudio = new Audio(url);
            newAudio.oncanplaythrough = () => {
              setAudio(newAudio);
              setIsPlaying(logId);
              setCurrentAudioId(logId);
              newAudio.play();
            };
            newAudio.onerror = (error) => {
              console.error("Error playing audio", error);
              setIsPlaying(false);
            };
            newAudio.onended = () => {
              setIsPlaying(false);
              window.URL.revokeObjectURL(url);
            };
          }
        } catch (error) {
          console.error("Error downloading or playing audio", error);
          setWaiting(false);
        } finally {
          setIsDownloading("");
          setWaiting(false);
        }
      },
      [audio, currentAudioId]
    );
     const fetchAudio = useCallback(async (logId) => {
        try {
          const audio = await downloadCallData(`/call-log/download/${logId}`);
          return audio;
        } catch (error) {
          console.error("Error fetching audio:", error);
          return null;
        }
      }, []);
      const downloadRecording = useCallback(
          async (logId) => {
            setIsDownloading(logId);
            const blob = await fetchAudio(logId);
            if (blob) {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${logId}.mp3`; // set the file name
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url); // free memory
            }
            setIsDownloading("");
          },
          [fetchAudio]
        );
      
      const replayAudio = useCallback(() => {
          if (audio) {
            audio.currentTime = 0; // Reset the audio to the beginning
            audio.play();
            setIsPlaying("true");
          }
        }, [audio]);
        const statusList = {
            0: "不在",
            1: "興味なし",
            3: "即断り",
            4: "着信拒否",
            5: "再アクション",
            6: "面談アサイン",
            7: "イベントアサイン",
            8: "電話番号不備",
            // 9: "接触前",
            10: "追客中",
            11: "サービス停止",
            12: "サービス停止（メールOK）",
            13: "前日確認OK",
            14: "キャンセル",
            15: "日程変更",
            16:"アポ獲得",
            17: "担当断り",
            18: "受付断り",
            19: "仮押さえ",
            20: "担当不在",
          };
    const log_columns = useMemo(
      () => [
        { title: "姓名", dataIndex: "name", key: "name", width: 170 },
        { title: "誕生日", dataIndex: "birthday", key: "birthday", width: 120 },
        {
          title: "応対者",
          dataIndex: "caller_name",
          key: "caller_name",
          width: 100,
          render: (caller_name) => <>{caller_name}</>,
        },
        {
          title: '部署',
          dataIndex: 'department_name',
          key: 'department_name',
          width: 100,
          filters: [...new Set(logData.map(item => item.department_name).filter(Boolean))]
              .map(name => ({ text: name, value: name })),
          onFilter: (value, record) => record.department_name === value,
        },
        {
          title: '課',
          dataIndex: 'section_name',
          key: 'section_name',
          width: 100,
          filters: [...new Set(logData.map(item => item.section_name).filter(Boolean))]
              .map(name => ({ text: name, value: name })),
          onFilter: (value, record) => record.section_name === value,

        },
        {
          title: 'チーム',
          dataIndex: 'team_name',
          key: 'team_name',
          width: 100,
          filters: [...new Set(logData.map(item => item.team_name).filter(Boolean))]
              .map(name => ({ text: name, value: name })),
          onFilter: (value, record) => record.team_name === value,
        },
        {
          title: "Zoom 応対者",
          dataIndex: "sys_caller_name",
          key: "sys_caller_name",
          width: 120,
          render: (sys_caller_name) => <>{sys_caller_name}</>,
        },
        { title: "フリガナ", key: "furigana", dataIndex: "furigana", width: 170 },
        { title: "通話日", dataIndex: "call_date", key: "call_date", width: 120 },
        {
          title: "再生",
          dataIndex: "url_recording",
          key: "url_recording",
          render: (url_recording, record) =>
            record.play_back === 1 ? (
              <Space>
                <Tooltip
                  title="再生/一時停止"
                  color="cyan"
                  key={`play_pause_${record.key}`}
                >
                  <a onClick={() => togglePlayPause(record.url_recording)}>
                    {isPlaying === record.url_recording ? (
                      <PauseCircleOutlined
                        style={{ color: "hotpink", fontSize: "20px" }}
                      />
                    ) : (
                      <PlayCircleOutlined
                        style={{ color: "#52c41a", fontSize: "20px" }}
                      />
                    )}
                  </a>
                </Tooltip>
                <Tooltip
                  title="最初から"
                  color="cyan"
                  key={`replay_${record.key}`}
                >
                  <a onClick={() => replayAudio()}>
                    <ReloadOutlined
                      style={{
                        color: "#55f",
                        fontSize: "20px",
                        marginLeft: "10px",
                      }}
                    />
                  </a>
                </Tooltip>
                <Tooltip
                  title="ダウンロード"
                  color="cyan"
                  key={`down_${record.key}`}
                >
                  {isDownloading === record.url_recording ? (
                    <LoadingOutlined
                      style={{
                        color: "blue",
                        fontSize: "20px",
                        marginLeft: "10px",
                      }}
                    />
                  ) : (
                    <a onClick={() => downloadRecording(record.url_recording)}>
                      <CloudDownloadOutlined
                        style={{
                          color: "hotpink",
                          fontSize: "20px",
                          marginLeft: "10px",
                        }}
                      />
                    </a>
                  )}
                </Tooltip>
              </Space>
            ) : null,
          width: 120,
        },
        {
          title: "結果の呼び出し",
          dataIndex: "result_call",
          key: "result_call",
          width: 130,
        },
        {
          title: "ステータス",
          dataIndex: "status",
          key: "status",
          render: (status, record) => (
            <>
              <Tag color={status ? "volcano" : "geekblue"}>
                {statusList[status] || ""}
              </Tag>
              {record.comments && (
                <div style={{ marginTop: "4px", fontSize: "12px", color: "#666" }}>
                  {record.comments}
                </div>
              )}
            </>
          ),
          filters: [...new Set(logData.map(item => item.status).filter(v => v !== null && v !== undefined))]
            .map(statusValue => ({
              text: statusList[statusValue] ?? statusValue,
              value: String(statusValue),
            })),
          onFilter: (value, record) => String(record.status) === value,
          width: 200,
        },
        {
          title: "性別",
          dataIndex: "gender",
          key: "gender",
          width: 120,
          render: (gender) => <>{gender}</>,
        },
        { title: "電話番号", dataIndex: "phone", key: "phone", width: 120 },
        { title: "住所", dataIndex: "address", key: "address", width: 120 },
        {
          title: "郵便番号",
          dataIndex: "postal_code",
          key: "postal_code",
          width: 120,
        },
        ...(is_enterprise
          ? [] // Empty array when is_enterprise is true, no extra columns
          : [
              {
                title: "大学名",
                dataIndex: "university_name",
                key: "university_name",
                width: 120,
              },
              {
                title: "学校種類",
                dataIndex: "school_type",
                key: "school_type",
                width: 120,
              },
              {
                title: "学部学科",
                dataIndex: "department",
                key: "department",
                width: 120,
              },
              {
                title: "文理",
                dataIndex: "educational_stream",
                key: "educational_stream",
                width: 130,
              },
              {
                title: "卒業年",
                dataIndex: "graduation_year",
                key: "graduation_year",
                width: 120,
              },
              {
                title: "就職希望年度",
                dataIndex: "work_year",
                key: "work_year",
                width: 120,
              },
              {
                title: "志望業界",
                dataIndex: "desired_industry",
                key: "desired_industry",
                width: 120,
              },
            ]),
        {
          title: "最終架電日",
          dataIndex: "last_call",
          key: "last_call",
          width: 145,
        },
      ],
      [isPlaying, isDownloading, togglePlayPause, replayAudio, downloadRecording, is_enterprise ,logData]
    );
  const handleCancel = () => {
    setIsModalOpen(false);
    isPlaying && togglePlayPause(isPlaying);
    if (audio) {
      audio.pause();
      setIsPlaying("");
    }
  };
  const fetchCallLog = async (user_id) => {
    setWaiting(true);
    try {
      const url = date == null
        ? `${logurlAPI}user_id=${user_id}`
        : `${logurlAPI}user_id=${user_id}&date=${date}`;

      const result = await getCallData(url);
      const callLogs = result.data || [];
      setLogData(callLogs);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching call logs:", error);
      messageApi.error("Error fetching call logs");
    } finally {
      setWaiting(false);
    }
  };
  const sensors = useSensors(
  useSensor(PointerSensor, {
    activationConstraint: {
      distance: 8,
    },
  })
);
const handleTableChange = (pagination, filters, sorter, extra) => {
  const newSortState = {
    columnKey: sorter.columnKey,
    order: sorter.order,
  };

  setSortState(newSortState);
  localStorage.setItem(sortStorageKey, JSON.stringify(newSortState));
  setFilteredData(extra.currentDataSource);

};


  const [reportColumnOrder, setReportColumnOrder] = useState(() => {
  const saved = localStorage.getItem(reportStorageKey);
  if (saved) {
    try { return JSON.parse(saved); }
    catch { return columns.map((col) => col.key); }
  }
  return columns.map((col) => col.key);
});

const [LogcolumnOrder, setLogColumnOrder] = useState(() => {
  const saved = localStorage.getItem(logStorageKey);
  if (saved) {
    try { return JSON.parse(saved); }
    catch { return log_columns.map((col) => col.key); }
  }
  return log_columns.map((col) => col.key);
});

    const orderedLogColumns = useMemo(
    () =>
      LogcolumnOrder
        .map((key) => log_columns.find((col) => col.key === key))
        .filter(Boolean)
        .map((col) => ({
          ...col,
          onHeaderCell: () => ({ "data-column-key": col.key }), // ← 追加
        })),
    [LogcolumnOrder, log_columns]
);
const handleReportDragEnd = ({ active, over }) => {
  if (!over || active.id === over.id) return;
  setReportColumnOrder((prev) => {
    const next = arrayMove(prev, prev.indexOf(active.id), prev.indexOf(over.id));
    localStorage.setItem(reportStorageKey, JSON.stringify(next));
    return next;
  });
};

const handleLogDragEnd = ({ active, over }) => {
  if (!over || active.id === over.id) return;
  setLogColumnOrder((prev) => {
    const next = arrayMove(prev, prev.indexOf(active.id), prev.indexOf(over.id));
    localStorage.setItem(logStorageKey, JSON.stringify(next));
    return next;
  });
};
const orderedReportColumns = useMemo(
  () =>
    reportColumnOrder
      .map((key) => columns.find((col) => col.key === key))
      .filter(Boolean)
      .map((col) => ({
        ...col,
        onHeaderCell: () => ({ "data-column-key": col.key }),
      })),
  [reportColumnOrder, columns]
);
const columnsWithSort = useMemo(() => {
  return orderedReportColumns.map((col) => ({
    ...col,
    sortOrder:
      sortState.columnKey === col.key ? sortState.order : null,
  }));
}, [orderedReportColumns, sortState]);
const tableSummary = useCallback(() => {
  const base = filteredData ?? repData(reportData);
  const total = {
    hit_call_per_day:      base.reduce((s, r) => s + (r.hit_call_per_day || 0), 0),
    call_per_day:          base.reduce((s, r) => s + (r.call_per_day || 0), 0),
    number_of_appointment: base.reduce((s, r) => s + (r.number_of_appointment || 0), 0),
    per_refuse:            base.reduce((s, r) => s + (r.per_refuse || 0), 0),
    total_duration:        base.reduce((s, r) => s + (r.total_duration || 0), 0),
  };

  // columnsWithSort の順序に合わせてセルを生成
  const cellMap = {
    name:                  <b>合計</b>,
    department_name:       null,
    section_name:          null,
    team_name:             null,
    hit_call_per_day:      <Tag color="#52c41a">{total.hit_call_per_day}</Tag>,
    call_per_day:          <Tag color="#52c41a">{total.call_per_day}</Tag>,
    number_of_appointment: <Tag color="#52c41a">{total.number_of_appointment}</Tag>,
    per_refuse:            <Tag color="#f55">{total.per_refuse}</Tag>,
    called_rate:           <Tag color="#f55">-</Tag>,
    total_duration:        <Tag color="#52c41a">{secondsToHHMMSS(total.total_duration)}</Tag>,
  };

  return (
    <Table.Summary fixed="top">
      <Table.Summary.Row style={{ background: "#fffbe6", fontWeight: "bold" }}>
        {columnsWithSort.map((col) => (
          <Table.Summary.Cell key={col.key} index={col.key}>
            {cellMap[col.key] ?? null}
          </Table.Summary.Cell>
        ))}
      </Table.Summary.Row>
    </Table.Summary>
  );
}, [filteredData, reportData, columnsWithSort]);
useEffect(() => {
  setFilteredData(null);
}, [reportData]);
  return (
    <Layout>
      <HeaderLayout />
      {contextHolder}
      <Layout>
        <NavBarLayout />
        <Content style={{ padding: "10px" ,...(isMobile && { marginTop: "64px" })}}>
          <div style={{ minHeight: 780 }}>
            {isLoading ? (
              <div
                style={{
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  backgroundColor: "transparent",
                  ...(isMobile && {}),
                }}
              >
                <Spin size="large" />
                <div className="ms-3 mt-2">読み込み中</div>{" "}
              </div>
            ) : (
              <>
              <Space style={{...(!isMobile && { justifyContent: "space-between" ,width:"100%",}),}}>
                <Space style={{                  ...(isMobile && { flexDirection: "column",width: "100%",alignItems: "start"}),
}}>
                  <h1>レポート</h1>
                  {isAdmin ? (<Select
                    showSearch
                    placeholder="応対者"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ width: 230 }}
                    onChange={(value) => handleChangeUser(value)}
                    value={updatedUser[user_id]?.value || optCurUsers[0]}
                    options={[...(optSysUsers || [])]}
                    loading={isWaiting}
                  />) : (<></>)}
                  <DatePicker
                    style={{ width: "100%" }}
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    placeholder="日にちを選択"
                    value={
                      type === "date" && date ? dayjs(date, "YYYY-MM-DD") : null
                    }
                    locale={jaJP.DatePicker}
                  />
                  <DatePicker
                    onChange={handleChangeMonth}
                    picker="month"
                    format="YYYY-MM"
                    placeholder="月を選択"
                    value={
                      type === "month" && date ? dayjs(date, "YYYY-MM") : null
                    }
                    locale={jaJP.DatePicker}
                  />
                  <Button
                    type="dashed"
                    danger
                    loading={isWaiting}
                    onClick={exportCSVData}
                  >
                    CSV出力
                  </Button>
                  <Button
                    type="dashed"
                    onClick={() => {
                      localStorage.removeItem(reportStorageKey);
                      localStorage.removeItem("report_sort_config");
                      setReportColumnOrder(columns.map((col) => col.key));
                    }}
                  >
                    テーブルリセット
                  </Button>
                  </Space>

                  {!isMobile && (
                    <div style={{marginRight:"2rem"}}>
                      <CurrentTimeDisplay />
                    </div>
                  )}
                </Space>

                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleReportDragEnd}
                >
                  <SortableContext
                    items={reportColumnOrder}
                    strategy={horizontalListSortingStrategy}
                  >
                    <Table
                    columns={columnsWithSort}
                    dataSource={repData(reportData)}
                    onChange={handleTableChange}
                      rowKey="key"
                      pagination={false}
                      scroll={{ y: 600, x: 680 }}
                      loading={isWaiting}
                      components={{ header: { cell: DraggableHeaderCell } }}
                       summary={tableSummary} 
                      onRow={(record) => ({
                        onClick: () => fetchCallLog(record.id),
                      })}
                    />
                  </SortableContext>
                </DndContext>
                <Modal
                  title="通話ログ"
                  open={isModalOpen}
                  onCancel={handleCancel}
                  footer={null}
                  width={1800}
                >
                  <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleLogDragEnd }
                    >
                      <SortableContext
                        items={LogcolumnOrder}
                        strategy={horizontalListSortingStrategy}
                      >
                      <Table
                          columns={orderedLogColumns}
                          dataSource={logData.map((item, index) => ({
                            key: index + 1,
                            candidate: item.candidate_id,
                            name: item.candidate_name,
                            furigana: item.furigana,
                            email: item.email,
                            phone: item.candidate_phone,
                            address: item.address,
                            birthday: item.birthday ? getShortDate(item.birthday) : "",
                            gender: item.gender,
                            postal_code: item.postal_code,
                            callee_number: item.callee_number,
                            school_type: item.school_type,
                            university_name: item.university_name,
                            educational_stream: item.educational_stream,
                            department: item.department,
                            graduation_year: item.graduation_year,
                            work_year: item.work_year,
                            desired_industry: item.desired_industry,
                            total_call: item.total_call,
                            last_call: formatDateToYYYYMMDDHHMMSS(item.call_end_time),
                            result_call: item.result,
                            author_id: item.author_id,
                            receipt_id: item.receipt_id,
                            status: item.status,
                            comments: item.comments,
                            call_date: formatDateToYYYYMMDDHHMMSS(item.date_time),
                            play_back: item.play_back,
                            caller_name: item.caller_name,
                            sys_caller_name: item.sys_caller_name,
                            url_recording: item?.call_record_id ?? "",
                            department_name: item.department_name,
                            section_name: item.section_name,
                            team_name: item.team_name,

                          }))}
                          rowKey="key"
                          pagination={false}
                          scroll={{ y: 690, x: 580 }}
                          loading={isWaiting}
                          components={{
                            header: {
                              cell: DraggableHeaderCell,
                            },
                          }}
                        />
                    </SortableContext>
                  </DndContext>
                </Modal>
              </>
            )}
          </div>
          <FooterLayout />
        </Content>
      </Layout>
    </Layout>
  );
};

export default CallReportZoom;
const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  text: {
    fontSize: "2rem",
    fontWeight: "bold",
    fontFamily:"Poppins",
  },

};
